(function () {
    'use strict';

    angular.module('Services').factory('RateHistoryTableService', RateHistoryTableService);

    RateHistoryTableService.$inject = ['Carrier', 'TableLiteFactory', 'toastr', '$timeout', '$filter'];

    function RateHistoryTableService(Carrier, TableLiteFactory, toastr, $timeout, $filter) {
        return function (serviceProfileId) {
            const tableStructure = {
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noFooter: false,
                    noExtraction: true,
                    noTopOptions: false,
                    tableHeight: '400px'
                },
                headers: [{
                    label: 'Date',
                    viewName: 'date'
                },{
                    label: 'RECIPIENT',
                    viewName: 'recipient'
                }, {
                    label: 'CC',
                    viewName: 'ccs'
                }],
                data: []
            };
            const tableActions = new TableLiteFactory(tableStructure,
                {
                    serviceCallback: Carrier.getRatePreview,
                    callbackFormat: ['id', 'success', 'error', 'filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                        //buildTableData(stubData);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters: {
                        size: 20,
                        page: 0,
                        sort: 'id,desc'
                    },
                    paramId: serviceProfileId
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (row) {
                    row.date = $filter('bbaDate')(row.createdDate);
                    row.ccs = row.cc.length !== 0 ? row.cc.join(', ') : 'N/A';
                    row.recipient = row.recipients.length !== 0 ? row.recipients.join(', ') : 'N/A' ; 
                    tableStructure.data.push(row);
                })
            }

            this.tableData = tableStructure;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/RateHistoryTableService.js